@if (showContactModal()) {
  <div class="z-50 fixed inset-0 flex justify-center items-center bg-black/50 p-4 privacy-modal-overlay">
    <app-contact-request-modal (closed)="closeContactModal()" />
  </div>
}

<section class="flex items-center bg-white user-req-hero">
  <div class="mx-auto w-[min(1280px,100%_-_2rem)]">

    @if (loading()) {
      <div class="flex justify-center items-center">
        <lib-loader></lib-loader>
      </div>
    } @else {

      @if (showAlert()) {
        <div class="my-10 wgt-alert" [class]="alertClass()">
          <div class="alert-icon">
            <img [src]="alertIcon()" alt="Icona di avviso">
          </div>
          <div class="alert-message">
            {{ alertMessage() }}
          </div>
        </div>
      }

      <div class="cols">
        <div class="left">
          <h1 class="greeting">Buongiorno, <span class="name">{{userProfile().element?.nome}} {{userProfile().element?.cognome}}</span></h1>
        </div>

        <div class="divider" aria-hidden="true"></div>

        <div class="right">
          <p class="intro">
            Per utilizzare il servizio di gestione delle collezioni digitali, scarica il modulo di richiesta di accreditamento e segui la procedura indicata.
          </p>

          <div class="actions">
            @if (userProfile().element?.emailConfirmed) {
              <dpac-button
                classe="primary"
                label="Scarica il modulo"
                (onClick)="downloadForm()"
              />
            } @else {
              <dpac-button
                classe="primary"
                label="Conferma email"
                (onClick)="goToOtpConfirmation()"
              />
            }
          </div>
        </div>
      </div>
    }
  </div>
</section>

<dpac-approfondimento
  [stepsTitle]="stepsTitle"
  [steps]="steps"
  (emitModal)="openContactModal()"
/>
